var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"},on:{"click":_vm.handleDownload}},[_vm._t("default",function(){return [_c('el-button',{attrs:{"type":"primary","size":"small"}},[_c('i',{staticClass:"el-icon-download"}),_vm._v(" 导出")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }